import MarketsChoiceAwards from "components/pages/Partners/images/MarketsChoiceAwards.png";
import CryptoCompare from "components/pages/Partners/images/CryptoCompare.png";
import AICPAImage from "public/static/images/pdp/05-cryptosecurity-soc-logo.png";
import NerdWallet from "components/pages/Partners/images/NerdWalletBadge.png";
import AscentBadge from "components/pages/Partners/images/AscentBadge.png";
import type { Translate } from "i18n/types";

export const getSecurityBadges = ({ t }: { t: Translate<"common"> }) => {
  return [
    {
      icon: NerdWallet,
      iconAlt: t("nerdBadgeAlt"),
      title: t("nerdBadgeTitle"),
      text: t("nerdBadgeText")
    },
    {
      icon: AICPAImage,
      iconAlt: t("AICPABadgeAlt"),
      title: t("AICPABadgeTitle"),
      text: t("AICPABadgeText")
    },
    {
      icon: CryptoCompare,
      iconAlt: t("ccBadgeAlt"),
      title: t("ccBadgeTitle"),
      text: t("ccBadgeText")
    },
    {
      icon: AscentBadge,
      iconAlt: t("ascentBadgeAlt"),
      title: t("ascentBadgeTitle"),
      text: t("ascentBadgeText")
    },
    {
      icon: MarketsChoiceAwards,
      iconAlt: t("mcaBadgeAlt"),
      title: t("mcaBadgeTitle"),
      text: t("mcaABadgeText")
    }
  ];
};
